module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["be_nl","be_fr","fi_fi","nl_nl","en","de_de","it_it","pl_pl","cz_cz","at_de","ch_de","ch_fr"],"defaultLanguage":"en","redirect":false,"i18nextOptions":{"nsSeparator":false}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
